import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-chat4-icon',
  templateUrl: './communication-chat4.component.html'
})
export class CommunicationChat4Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
